import * as Yup from 'yup';

export interface IChangePasswordForm {
  oldPassword: string;
  password: string;
  passwordConfirmation: string;
}

export const initialValues: IChangePasswordForm = {
  oldPassword: '',
  password: '',
  passwordConfirmation: '',
};

export const validationSchema = Yup.object({
  oldPassword: Yup.string().required('validation.required'),
  password: Yup.string()
    .required('validation.required')
    .min(8, 'validation.min8')
    .matches(/^(?=.*[A-Z])/, 'validation.one_uppercase')
    .matches(/^(?=.*[a-z])/, 'validation.one_lowercase')
    .matches(/^(?=.*[0-9])/, 'validation.one_number'),
  passwordConfirmation: Yup.string()
    .required('validation.required')
    .test('password-match', 'validation.password_match', function (v: any) {
      return this.parent.password === v;
    }),
});
